import { type FC } from "react";

import { Card, Center, Flex, Loader } from "@mantine/core";

import { MetricField } from "../../gql-generated/types";
import { useTimeRange } from "../../lens-insights/hooks";
import { GranularityInDays, LensGranularity } from "../../lens-insights/models";
import { StatsCard } from "../../shared/components";
import { useHomeStats } from "../hooks/useHomeStats";

import {
    card,
    header,
    headerIcon,
    headerSubtitle,
    headerText,
    headerTitle,
    statsRow,
} from "./HomeEngagementReachCard.module.css";
import {
    EngagementAndReach,
    EngagementAndReachSubtitle,
    StatsTotalPlays,
    StatsTotalPlaysTooltip,
    StatsTotalReach,
    StatsTotalReachTooltip,
    StatsTotalShares,
    StatsTotalSharesTooltip,
    StatsVsPrevious,
} from "./messages.generated";

export const HomeEngagementReachCard: FC = () => {
    const { stats, loading } = useHomeStats();
    const { selectedTimeRange } = useTimeRange({ defaultRange: LensGranularity.Lifetime });
    const days = GranularityInDays[selectedTimeRange];
    const diffText = days ? <StatsVsPrevious days={days.toString()} /> : null;

    const reach = stats[MetricField.LensViewers];
    const plays = stats[MetricField.LensPlays];
    const shares = stats[MetricField.LensShares];

    return (
        <Card shadow="sm" radius={0} p={0} className={card}>
            <div className={header}>
                <span className={headerIcon} aria-hidden="true">
                    📈
                </span>
                <div className={headerText}>
                    <div className={headerTitle}>
                        <EngagementAndReach />
                    </div>
                    <div className={headerSubtitle}>
                        <EngagementAndReachSubtitle />
                    </div>
                </div>
            </div>
            {loading ? (
                <Center h={120}>
                    <Loader />
                </Center>
            ) : (
                <Flex className={statsRow}>
                    <StatsCard
                        label={<StatsTotalReach />}
                        tooltip={<StatsTotalReachTooltip />}
                        value={reach?.value ?? "-"}
                        diffValue={reach?.diffValue ?? null}
                        diffText={diffText}
                        size="hero"
                    />
                    <StatsCard
                        label={<StatsTotalPlays />}
                        tooltip={<StatsTotalPlaysTooltip />}
                        value={plays?.value ?? "-"}
                        diffValue={plays?.diffValue ?? null}
                        diffText={diffText}
                        size="hero"
                    />
                    <StatsCard
                        label={<StatsTotalShares />}
                        tooltip={<StatsTotalSharesTooltip />}
                        value={shares?.value ?? "-"}
                        diffValue={shares?.diffValue ?? null}
                        diffText={diffText}
                        size="hero"
                    />
                </Flex>
            )}
        </Card>
    );
};
